var SoundService = function () {
  var audio = new Audio(require('../assets/sound.mp3'))

  if (localStorage.getItem('volume')) {
    audio.volume = parseFloat(localStorage.getItem('volume'))
  }

  if (localStorage.getItem('muted')) {
    audio.muted = localStorage.getItem('muted')
  }

  return {
    play: function () {
      audio.play()
    },
    setVolume: function (volume) {
      audio.volume = volume
      localStorage.setItem('volume', volume)
    },
    getVolume: function () {
      return audio.volume
    },
    mute: function (muted) {
      audio.muted = muted
      localStorage.setItem('muted', muted)
    },
    isMuted: function () {
      return audio.muted
    }
  }
}
export default new SoundService()



// WEBPACK FOOTER //
// ./src/services/SoundService.js